import { Form } from 'antd'
import { useNavigate } from 'react-router-dom'
import { apiCreateOutlet } from '../../api'
import { OUTLET } from '../../assets/constants/route_path'
import ButtonBack from '../../components/button/ButtonBack'
import OutletForm from '../../components/outlet/OutletForm'
import { useLoading } from '../../context/LoadingContext'
import { toastError, toastSuccess } from '../../utils/toast'

export default function OutletCreate() {
    const [form] = Form.useForm()
    const navigate = useNavigate()
    const { setIsLoading } = useLoading()

    const handleSubmit = async (values: any) => {
        try {
            setIsLoading(true)
            const resp: any = await apiCreateOutlet(values)
            if (resp.status === 200) {
                toastSuccess('Thêm đại lý thành công!')
                form.resetFields()
                navigate(OUTLET)
                return
            }
            toastError('Có lỗi xảy ra!')
        } catch (error) {
            console.log(error)
            toastError('Có lỗi xảy ra!')
        } finally {
            setIsLoading(false)
        }
    }

    return (
        <div>
            <ButtonBack to={OUTLET} />
            <h2>Thêm đại lý mới</h2>
            <OutletForm form={form} onSubmit={handleSubmit} submitLabel='Thêm' onCancel={() => navigate(OUTLET)} />
        </div>
    )
}
